<div class="forbidden-page flex flex-col w-full items-center justify-center">
  <svg class="forbidden-illustration text-primary" viewBox="0 0 200 200" role="img" aria-label="Accès verrouillé">
    <circle cx="100" cy="104" r="88" fill="currentColor" opacity="0.08" />
    <circle cx="100" cy="104" r="66" fill="currentColor" opacity="0.1" />
    <path
      d="M68 96 V74 a32 32 0 0 1 64 0 v22"
      fill="none"
      stroke="currentColor"
      stroke-width="13"
      stroke-linecap="round"
    />
    <rect x="52" y="96" width="96" height="72" rx="14" fill="currentColor" />
    <circle cx="100" cy="126" r="10" fill="#ffffff" />
    <rect x="95" y="130" width="10" height="20" rx="5" fill="#ffffff" />
  </svg>
  <p class="text-xl">{{ accessDeniedMessage }}</p>
  <p
    *ngIf="missingPermissionMessage"
    class="mt-3 px-4 py-2 rounded-full bg-primary-light text-primary text-sm font-medium"
  >
    🔒 {{ missingPermissionMessage }}
  </p>
  <p class="text-secondary mt-2">
    Si vous pensez qu'il s'agit d'une erreur, rapprochez-vous de votre administrateur pour vérifier les droits de votre
    rôle.
  </p>
  <div class="flex flex-row gap-3 mt-6">
    <button mat-stroked-button color="primary" (click)="goBack()">Retour</button>
    <button mat-raised-button color="primary" (click)="redirectToHome()">Aller à l'accueil</button>
  </div>
</div>
